import type { Messages } from '../catalogue.en'

export const anamnesis: Partial<Messages> = {
  'anamnesis.title': 'Анамнез',
  'anamnesis.description': 'Анамнез жизни и аллергологический анамнез — общие для всей карты, с историей версий.',
  'anamnesis.loading': 'Загрузка анамнеза…',
  'anamnesis.loadFailed': 'Не удалось загрузить анамнез.',
  'anamnesis.forbidden': 'Ваша роль не позволяет просматривать анамнез.',
  'anamnesis.notFound': 'Пациент не найден.',
  'anamnesis.empty': 'Анамнез ещё не заполнен',
  'anamnesis.emptyDetail': 'Заполните анамнез жизни и аллергии один раз — дальше каждый приём будет его видеть.',
  'anamnesis.edit': 'Изменить',
  'anamnesis.protocolEdit': 'Изменить в карте',
  'anamnesis.protocolSealedNone': 'С подписанным протоколом анамнез не закреплён.',
  'anamnesis.record': 'Заполнить анамнез',
  'anamnesis.save': 'Сохранить',
  'anamnesis.saving': 'Сохранение…',
  'anamnesis.cancel': 'Отмена',
  'anamnesis.saved': 'Сохранено как версия {revision}.',
  'anamnesis.historyShow': 'История версий',
  'anamnesis.historyHide': 'Скрыть историю',
  'anamnesis.historyTitle': 'История версий',
  'anamnesis.historyEmpty': 'Версий пока нет.',
  'anamnesis.historyFailed': 'Не удалось загрузить историю версий.',
  'anamnesis.historyMore': 'Показать более ранние версии',
  'anamnesis.version': 'Версия {revision}',
  'anamnesis.recordedAt': 'Записано {when}',
  'anamnesis.recordedBy': 'Записано {when}, {who}',
  'anamnesis.allergiesTitle': 'Аллергологический анамнез',
  'anamnesis.allergyStatus': 'Аллергологический статус',
  'anamnesis.lifeHistoryTitle': 'Анамнез жизни',
  'anamnesis.lifeHistoryEmpty': 'Анамнез жизни не заполнен.',
  'anamnesis.entryKind': '{type} — {category}',
  'anamnesis.manifestations': 'Реакции',
  'anamnesis.listSeparator': ', ',
  'anamnesis.note': 'Примечание',
  'anamnesis.entryLegend': 'Аллергия {number}',
  'anamnesis.entryType': 'Вид',
  'anamnesis.entryCategory': 'Категория',
  'anamnesis.criticalityLabel': 'Риск',
  'anamnesis.criticalityNone': 'Не указан',
  'anamnesis.substance': 'Аллерген',
  'anamnesis.substanceBrowse': 'Выбрать в справочнике',
  'anamnesis.dictionaryTitleDrug': 'Лекарственные вещества',
  'anamnesis.dictionaryTitleOther': 'Прочие аллергены',
  'anamnesis.dictionaryTabCatalogue': 'Справочник',
  'anamnesis.dictionarySearchPlaceholder': 'Название вещества',
  'anamnesis.dictionaryHintClassified': 'Откройте группу АТХ или введите не менее двух букв международного непатентованного названия. Торговых названий в справочнике нет.',
  'anamnesis.dictionaryHint': 'Введите не менее двух букв названия или выберите из списка.',
  'anamnesis.dictionaryUnclassified': 'Без группы АТХ',
  'anamnesis.dictionaryOtherLetters': 'Прочие символы',
  'anamnesis.dictionaryMore': 'Показать ещё',
  'anamnesis.dictionaryLoading': 'Загрузка справочника…',
  'anamnesis.dictionarySearching': 'Поиск…',
  'anamnesis.dictionaryLoadFailed': 'Не удалось загрузить справочник.',
  'anamnesis.dictionarySearchFailed': 'Не удалось выполнить поиск по справочнику.',
  'anamnesis.dictionarySearchEmpty': 'В справочнике ничего не найдено.',
  'anamnesis.dictionaryEmptyLevel': 'В этой группе пусто.',
  'anamnesis.dictionarySearchResults': 'Результаты поиска',
  'anamnesis.clearCoding': 'Убрать код справочника',
  'anamnesis.reactionText': 'Реакция своими словами',
  'anamnesis.addReaction': 'Добавить реакцию',
  'anamnesis.reactionSearch': 'Найти реакцию в справочнике',
  'anamnesis.removeReaction': 'Убрать реакцию {name}',
  'anamnesis.removeEntry': 'Удалить аллергию {number}',
  'anamnesis.addEntry': 'Добавить аллергию',
  'anamnesis.habitSearch': 'Найти привычку в справочнике',
  'anamnesis.removeCode': 'Убрать {name}',
  'anamnesis.problemNoEntries': 'Укажите хотя бы одну аллергию или выберите другой статус.',
  'anamnesis.problemNoSubstance': 'У каждой аллергии должен быть указан аллерген.',
  'anamnesis.changedConcurrently': 'Анамнез изменился, пока вы его редактировали.',
  'anamnesis.codingInvalid': 'Код справочника не принят. Выберите его из списка ещё раз.',
  'anamnesis.codingUnbound': 'Для этого поля в клинике не настроен справочник. Уберите код и оставьте текст.',
  'anamnesis.writeSessionEnded': 'Сеанс завершён. Войдите снова, чтобы сохранить.',
  'anamnesis.writeForbidden': 'Ваша роль не позволяет изменять анамнез.',
  'anamnesis.writeInvalid': 'Анамнез не принят. Проверьте поля и попробуйте снова.',
  'anamnesis.writeUnavailable': 'Сервер недоступен. Изменения остались в форме — попробуйте снова.',
  'anamnesis.writeFailed': 'Не удалось сохранить анамнез. Попробуйте снова.',
  'anamnesis.conflictTitle': 'Пока вы редактировали, сохранена версия {revision}.',
  'anamnesis.conflictDetail': 'Ваши изменения остались в форме. Сохраните их поверх новой версии или отмените и посмотрите сохранённое.',
  'anamnesis.conflictOverwrite': 'Сохранить мою версию поверх',
  'anamnesis.conflictDiscard': 'Отменить мои изменения',
  'anamnesis.markTitle': 'Аллергии:',
  'anamnesis.markOpen': 'Открыть анамнез',
  'anamnesis.markMore': 'ещё {count}',
  'anamnesis.section.pastIllnesses': 'Перенесённые заболевания',
  'anamnesis.section.surgeriesInjuries': 'Операции и травмы',
  'anamnesis.section.familyHistory': 'Наследственность',
  'anamnesis.section.livingConditions': 'Условия жизни и труда',
  'anamnesis.section.habits': 'Вредные привычки',
  'anamnesis.section.obstetricGynecological': 'Акушерско-гинекологический анамнез',
  'anamnesis.section.transfusions': 'Гемотрансфузии',
  'anamnesis.section.medications': 'Постоянный приём лекарств',
  'anamnesis.section.other': 'Прочее',
  'anamnesis.status.recorded': 'Есть аллергии или непереносимость',
  'anamnesis.status.noneKnown': 'Аллергологический анамнез не отягощён',
  'anamnesis.status.unknown': 'Не выяснено',
  'anamnesis.type.allergy': 'Аллергия',
  'anamnesis.type.intolerance': 'Непереносимость',
  'anamnesis.category.medication': 'Лекарство',
  'anamnesis.category.food': 'Пища',
  'anamnesis.category.insect': 'Насекомые',
  'anamnesis.category.other': 'Другое',
  'anamnesis.criticality.low': 'Низкий риск',
  'anamnesis.criticality.high': 'Высокий риск',
  'anamnesis.criticality.unableToAssess': 'Риск не оценён',
}
